module.exports = __webpack_public_path__ + "img/cooling-ac-by-porch.79750a59.jpg";